import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import { getUserProfile } from "../services/user_services.tsx";

// slike
const background = require("../assets/background.png");
const acoinLogo = require("../assets/ACOIN logo.png");
const girl = require("../assets/girl.png");
const coin = require("../assets/coin.png");

const Welcome = () => {
  const [isLogged, setIsLogged] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [showLogo, setShowLogo] = useState(true);
  const [loading, setLoading] = useState(true);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const images = [background, acoinLogo, girl, coin];

    let loaded = 0;

    images.forEach((src) => {
      const img = new Image();
      img.src = src;

      const done = () => {
        loaded++;
        if (loaded === images.length) {
          setImagesLoaded(true);
        }
      };

      img.onload = done;
      img.onerror = done;
    });
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      setIsLogged(false);
      setLoading(false);
      return;
    }

    const fetchUserData = async () => {
      try {
        await getUserProfile(token);
        setIsLogged(true);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  // kontrola logo prikaza
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 700) {
        setShowLogo(false);
      } else {
        setShowLogo(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCoinClick = () => {
    if (isSpinning) return;

    setIsSpinning(true);

    setTimeout(() => {
      navigate("/login");
    }, 800);
  };

  if (loading || !imagesLoaded) {
    return (
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "black",
        }}
      >
        <CircularProgress size={80} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <img
        src={background}
        alt="Background"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 0,
        }}
      />

      {showLogo && (
        <Box
          sx={{
            position: "absolute",
            top: "45%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
            width: "700px",
            maxWidth: "85vw",
          }}
        >
          <img
            src={acoinLogo}
            alt="ACOIN"
            style={{
              width: "100%",
              display: "block",
            }}
          />

          <Box
            onClick={handleCoinClick}
            sx={{
              position: "absolute",
              left: "52.5%",
              top: "48%",
              transform: "translate(-50%, -50%)",
              zIndex: 3,
              cursor: "pointer",

              ...(isSpinning && {
                animation: "coinSpin 0.8s linear",
              }),

              "&:hover": {
                transform: isSpinning
                  ? "translate(-50%, -50%)"
                  : "translate(-50%, -50%) scale(1.1)",
                filter: "drop-shadow(0 0 20px gold)",
              },
            }}
          >
            <img
              src={coin}
              alt="coin"
              style={{
                width: "115%",
                maxWidth: "210px",
                pointerEvents: "none",
              }}
            />
          </Box>
        </Box>
      )}

      {!showLogo && (
        <Box
          onClick={handleCoinClick}
          sx={{
            position: "absolute",
            left: showLogo ? "51.5%" : "40%",
            top: showLogo ? "48%" : "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 3,
            cursor: "pointer",

            ...(isSpinning && {
              animation: "coinSpin 0.8s linear",
            }),

            "&:hover": {
              transform: isSpinning
                ? "translate(-50%, -50%)"
                : "translate(-50%, -50%) scale(1.1)",
              filter: "drop-shadow(0 0 20px gold)",
            },
          }}
        >
          <img
            src={coin}
            alt="coin"
            style={{
              width: "220%",
              maxWidth: "320px",
              minWidth: "180px",
              pointerEvents: "none",
            }}
          />
        </Box>
      )}

      <Box
        sx={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          height: "82%",
          zIndex: 1,
          display: { xs: "none", md: "block" },
        }}
      >
        <img
          src={girl}
          alt="AI"
          style={{
            height: "82%",
            width: "auto",
            objectFit: "cover",
            objectPosition: "top right",
          }}
        />
      </Box>

      <style>
        {`
          @keyframes coinSpin {
            0% {
              transform: translate(-50%, -50%) scale(1) rotate(0deg);
            }
            30% {
              transform: translate(-50%, -50%) scale(1.5) rotate(90deg);
            }
            100% {
              transform: translate(-50%, -50%) scale(1.5) rotate(360deg);
            }
          }
        `}
      </style>
    </Box>
  );
};

export default Welcome;